import React from 'react';

import BaseComponent from 'src/components/BaseComponent';
import { RadiosField, Spinner } from 'src/components/basic';

import { lang, remCss } from 'src/helpers';
import moment from 'moment/moment';
import constants from 'src/constants';
import MonthSelector from './SlotMonthCalendar';
import LANG_CONST from '../../helpers/lang/const';
import { CarrouselDaysOfMonth } from '../complex/CarrouselDaysOfMonth';
const defaultCurrency = constants.general.defaultCurrency;

class SlotCalendar extends BaseComponent {
  renderDays() {
    const { slots, selectedDay: d, handleChangeSelectedDay } = this.props;
    const selectedDay = moment(d);
    const startDate = moment().isSame(selectedDay, 'month')
      ? moment()
      : selectedDay.clone().startOf('month');
    const endDate = startDate.clone().endOf('month');

    return (
      <CarrouselDaysOfMonth
        enabledFn={(day) => {
          return !!slots.find((slot) => day.isSame(moment(slot.startDate), 'day'));
        }}
        selectedDay={selectedDay}
        handleChangeSelectedDay={handleChangeSelectedDay}
        startDate={startDate}
        endDate={endDate}
      />
    );
  }

  renderTimes() {
    let { slots, selectedDay, appointment, edit = false, handleChangeSelectedSlot } = this.props;
    return slots
      .filter((slot) => moment(selectedDay).isSame(moment(slot.startDate), 'day'))
      .map((slot) => {
        let classEx = slot.patientId ? 'booked' : selectedDay === slot.startDate ? 'active' : '';
        if (edit) {
          classEx =
            selectedDay === slot.startDate
              ? 'active'
              : !!slot.patientId && slot.id !== appointment.data.slotId
                ? 'booked'
                : '';
        }

        return (
          <div
            key={slot.id}
            className={'mc-time ' + classEx}
            onClick={() => {
              if (classEx !== '') return;
              handleChangeSelectedSlot(slot);
            }}
          >
            {moment(slot.startDate).format('h:mm a')}
          </div>
        );
      });
  }

  scrollToDate = () => {
    const query = document.querySelector('.mc-day.active');
    query &&
      query.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
        inline: 'center'
      });
  };

  render() {
    const {
      fees,
      currency = defaultCurrency,
      loading,
      slots,
      selectedSlot,
      selectedDay,
      selectedType,
      payNow,
      payLifeapp,
      handleChangeSelectedMonth,
      handleChangeSelectedType,
      handleChangePayNow,
      handleChangePayLifeapp,
      isPatient = true
    } = this.props;

    const fee = selectedType === 'virtual' ? fees?.virtual : fees?.office;

    return (
      <>
        <div className={'mc-flex'}>
          <span className={'mc-grow mc-title'}>
            {selectedDay &&
              lang.t(LANG_CONST.select_date) + ': ' + moment(selectedDay).format('MMMM DD, YYYY')}
          </span>
          <MonthSelector
            selectedDay={selectedDay}
            minDate={moment().startOf('month').valueOf()}
            onChange={handleChangeSelectedMonth}
          />
        </div>
        {this.renderDays()}
        <div className={'mc-note'} />
        {/*<div className={'mc-flex'}>*/}
        {/*  <span className={'mc-grow mc-title'}>{lang.t('Select time')}</span>*/}
        {/*  <div className={'mc-book-symbol'}>*/}
        {/*    <div/>*/}
        {/*    {lang.t('Booked')}*/}
        {/*  </div>*/}
        {/*</div>*/}
        {slots?.filter((s) => !s.patientId).length ? (
          <div className={'mc-time-box'}>{this.renderTimes()}</div>
        ) : (
          <div className={'mc-notfound'}>{lang.t(LANG_CONST.text.not_slot_yet)}</div>
        )}
        {selectedSlot && (
          <div className={'mc-flex'}>
            <span className={'mc-grow mc-title'}>{lang.t(LANG_CONST.treatment_prefer)}</span>
          </div>
        )}
        {loading ? (
          <div className={'mc-flex'}>
            <Spinner />
          </div>
        ) : (
          <div className={'mc-flex-col mc-grow'}>
            {selectedSlot && (
              <div className={'mc-flex'}>
                <RadiosField
                  template={'3'}
                  list={constants.general.appointment_types.filter(
                    (item) => (selectedSlot.appointmentTypes || []).indexOf(item.value) > -1
                  )}
                  data={selectedType}
                  onChange={handleChangeSelectedType}
                />
              </div>
            )}
            {selectedType &&
              !!fee &&
              (selectedType === 'virtual' ? (
                <div className={'mc-note-2'}>
                  {isPatient && lang.t(LANG_CONST.text.appointment_virtual_amount_prefix)}{' '}
                  <span>
                    {fees?.virtual} {currency} / {lang.t(LANG_CONST.session)}
                  </span>{' '}
                  {lang.t(LANG_CONST.text.appointment_virtual_amount_suffix)}.
                </div>
              ) : (
                <div className={'mc-flex'} style={{ marginTop: remCss(20) }}>
                  <div className={'mc-grow mc-flex-col'}>
                    {selectedSlot?.hospital.split('\n').map((txt, i) => (
                      <div className={i === 0 ? ' mc-note-2' : ''} key={i}>
                        {i === 0 ? txt.split('_')[0] : txt}
                      </div>
                    ))}
                  </div>
                  <span className={' mc-note-3'}>
                    {fees?.office} {currency}
                  </span>
                </div>
              ))}
            {!!handleChangePayLifeapp && selectedType === 'in_office' && !!fee && (
              <div>
                <div className={'mc-flex'}>
                  <span className={'mc-grow mc-title'}>{lang.t(LANG_CONST.payment_method)}</span>
                </div>
                <div className={'mc-flex'} style={{ marginTop: 10 }}>
                  <RadiosField
                    template={'3'}
                    list={[
                      { value: false, label: LANG_CONST.in_office },
                      { value: true, label: 'LifeApp' }
                    ]}
                    data={payLifeapp}
                    onChange={handleChangePayLifeapp}
                  />
                </div>
              </div>
            )}
            {!!handleChangePayNow &&
              isPatient &&
              !!fee &&
              (selectedType === 'virtual' || (selectedType === 'in_office' && payLifeapp)) && (
                <div className={'mc-flex'} style={{ marginTop: 10 }}>
                  <RadiosField
                    template={'3'}
                    list={[
                      { value: true, label: LANG_CONST.constants.pay_types.now },
                      { value: false, label: LANG_CONST.constants.pay_types.later }
                    ]}
                    data={payNow}
                    onChange={handleChangePayNow}
                  />
                </div>
              )}
          </div>
        )}
      </>
    );
  }
}

export default SlotCalendar;
